module.exports = __webpack_public_path__ + "static/media/limit.3bbb6efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/limit.png
// module id = 577
// module chunks = 4